export default __webpack_public_path__ + "static/media/nigeria.c69beb51.jpg";